import { render, staticRenderFns } from "./NameNsDescription.vue?vue&type=template&id=51dcf5ea&scoped=true&"
import script from "./NameNsDescription.vue?vue&type=script&lang=js&"
export * from "./NameNsDescription.vue?vue&type=script&lang=js&"
import style0 from "./NameNsDescription.vue?vue&type=style&index=0&id=51dcf5ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcf5ea",
  null
  
)

export default component.exports